/**
 * Gets the sort by property for the given table
 * @param tableView for which to find the soryBy
 * @returns the sortBy property for the given table
 */
export default function getSortByForTable(tableView) {
    switch (tableView.tableQuery.type) {
        case 0 /* Folder */:
        case 2 /* Group */:
            return tableView.tableQuery.sortBy;
        default:
            throw new Error('getSortByForTable: Table Query type should be either of type group or mail folder');
    }
}
//# sourceMappingURL=getSortByForTable.js.map